import React, { Component } from 'react';
import './appStyle.less';

class AppPay extends Component {
    constructor(props){
        super(props);
        this.state = {
            sectionId:0
        }
        this.pushPage = props.pushPage;
    }
    tabFun(id,canBuy,reason){
        this.setState({sectionId:id})
        console.log(canBuy,reason)
        // if(!canBuy) alert(reason)
        // else{
            window.location.href = `${window.location.origin}/h5/h5pay${window.location.search}&goodsId=${id}&lessondate=${new Date(this.props.lessonDate.replace(/\./g,'/')).getTime()}`;
        // }
        // this.pushPage('h5pay',id)
    }
    render(){
        const _this = this;
        const goodsInfo = this.props.goodsInfo;
        const sectionItem = goodsInfo.map((ele,index)=>{
            return(
                <Section 
                key={index}
                canBuy={ele.canBuy}
                reason={ele.reason}
                num={ele.lessons} price={(ele.totalAmount)/100} 
                expireDays={ele.expireDays} 
                clickFun={(canBuy,reason)=>_this.tabFun(index,canBuy,reason)} 
                />
            )
        })
        return(
            <div className="container apppay">
                <div className="top">
                    <div className="head">剩余课时<span>{this.props.lessonCnt}</span>节</div>
                    <div className="sub_head">有效期至：{this.props.lessonDate}<span></span></div>
                </div>
                {sectionItem}
                {!this.props.goodsInfo.length &&
                    <div className="nolessons">暂时没有可购买的课时</div>
                }
            </div>
        )
    }
}

const Section = props =>{
    return(
        <div className="section">
            <div className="section_left">
                <div>
                    <span className='num'>{props.num}</span>
                    <span className='text'>课时</span>
                    <span className='price'>{props.price || 0}</span>
                    <span className='text'>元</span>
                </div>
                <div className='sub'>
                    <span className='subtext'>有效期{props.expireDays}天</span>
                </div>
            </div>
            <div className="section_right" onClick={()=>{props.clickFun(props.canBuy,props.reason)}} >
                购买
            </div>
        </div>
    )
}

export default AppPay;



// WEBPACK FOOTER //
// ./src/template/Pay/AppPay.jsx